export default "__VITE_ASSET__BtooQ79m__"